var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_18455)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10487_18455)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFEEB3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0554,
    y: 29.3222,
    width: 17.7333,
    height: 4.51111,
    rx: 2.25556,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.466667
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10487_18455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.84525,
    y: 47.112,
    width: 33.7556,
    height: 35.7778,
    rx: 16.8778,
    transform: "rotate(-16 6.84525 47.112)",
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.466667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9444,
    y: 37.8778,
    width: 9.48889,
    height: 4.51111,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.466667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1781,
    y: 37.6444,
    width: 9.02222,
    height: 6.22222,
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7664,
    y: 17.4999,
    width: 14.3111,
    height: 22.5556,
    rx: 7.15556,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.466667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 24.7333H22.2446L21 27.6893V24.7333Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8445 24.7333H33.5999L34.8445 27.6893V24.7333Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_10487_18455",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2234 43.711C35.9176 46.1321 32.3179 48.0431 27.9223 48.0431C23.5521 48.0431 19.9688 46.1542 19.6268 43.753C13.7731 45.4295 9.48901 50.8212 9.48901 57.2135V67.7913H46.5112V57.2135C46.5112 50.7667 42.1538 45.3377 36.2234 43.711Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2234 43.711C35.9176 46.1321 32.3179 48.0431 27.9223 48.0431C23.5521 48.0431 19.9688 46.1542 19.6268 43.753C13.7731 45.4295 9.48901 50.8212 9.48901 57.2135V67.7913H46.5112V57.2135C46.5112 50.7667 42.1538 45.3377 36.2234 43.711Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2234 43.711L36.3469 43.2609L35.8279 43.1186L35.7604 43.6525L36.2234 43.711ZM19.6268 43.753L20.0888 43.6872L20.0132 43.1569L19.4983 43.3044L19.6268 43.753ZM9.48901 67.7913H9.02235V68.2579H9.48901V67.7913ZM46.5112 67.7913V68.2579H46.9779V67.7913H46.5112ZM35.7604 43.6525C35.635 44.6454 34.8147 45.6242 33.3897 46.3717C31.9795 47.1115 30.0575 47.5764 27.9223 47.5764V48.5097C30.1827 48.5097 32.2583 48.0192 33.8233 47.1982C35.3735 46.385 36.506 45.1977 36.6864 43.7695L35.7604 43.6525ZM27.9223 47.5764C25.7996 47.5764 23.8873 47.1169 22.4793 46.3845C21.0566 45.6445 20.2293 44.6738 20.0888 43.6872L19.1648 43.8188C19.3662 45.2335 20.5016 46.4078 22.0486 47.2125C23.6104 48.0248 25.6749 48.5097 27.9223 48.5097V47.5764ZM9.95568 57.2135C9.95568 51.035 14.0965 45.8224 19.7552 44.2017L19.4983 43.3044C13.4498 45.0367 9.02235 50.6075 9.02235 57.2135H9.95568ZM9.95568 67.7913V57.2135H9.02235V67.7913H9.95568ZM46.5112 67.3246H9.48901V68.2579H46.5112V67.3246ZM46.0446 57.2135V67.7913H46.9779V57.2135H46.0446ZM36.1 44.161C41.8328 45.7335 46.0446 50.9823 46.0446 57.2135H46.9779C46.9779 50.5512 42.4747 44.9418 36.3469 43.2609L36.1 44.161Z",
    fill: "#111111",
    mask: "url(#path-11-inside-1_10487_18455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4882 20.0148L34.4976 20.0336L34.5103 20.0505C34.9178 20.5932 35.1769 20.9681 35.3641 21.3644C35.5499 21.7575 35.6699 22.1827 35.7814 22.8285L35.7829 22.8371L35.7849 22.8454C36.01 23.7458 36.0113 24.9129 36.0113 25.5888C36.0113 26.1116 35.8668 31.0599 35.8052 33.1453C35.7862 33.7885 36.072 34.3999 36.5748 34.7991H35.0987L35.1115 28.3028V28.3024V27.7648V27.3437L34.7545 27.567C34.2089 27.9081 33.7575 28.1095 33.2548 28.2282C32.7491 28.3475 32.18 28.3859 31.3927 28.386C30.0795 28.3244 28.9117 27.4965 28.0991 26.3969C27.4553 25.5257 26.5143 24.768 25.3666 24.7147L21.4 24.5304C21.1839 24.5203 21.0011 24.6887 20.9934 24.9049L20.9083 27.2839H20.9083L20.9082 27.2861L20.7072 34.8897H19.5926C19.5713 34.8897 19.5588 34.8836 19.5504 34.8771C19.5406 34.8696 19.5316 34.8575 19.5264 34.8417C19.5213 34.826 19.5214 34.8108 19.5249 34.799C19.5278 34.7888 19.5342 34.7765 19.5515 34.7639C19.9817 34.4485 20.23 33.9423 20.216 33.409L19.9892 24.7578C20.0793 22.553 20.9428 20.5331 22.5687 19.0406L22.5687 19.0406L22.57 19.0394C23.2288 18.4252 23.9755 17.942 24.7669 17.5899L24.8673 17.5514C26.8903 16.7755 29.1228 16.7419 31.1682 17.4565C32.4346 17.9813 33.5739 18.8539 34.454 19.9465L34.4882 20.0148Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.466667
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 54.5,
    height: 54.5,
    rx: 27.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_18455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10487_18455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10487_18455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2222,
    height: 49.7778,
    fill: "white",
    transform: "translate(10.8889 3.73337)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric06);
export default __webpack_public_path__ + "static/media/Generic 06.0c926ca3e5b096bf221e5c4a4f1fd399.svg";
export { ForwardRef as ReactComponent };